import PropTypes from "prop-types"
import "./style.scss"

function LoadingError({ text }) {
  return <div className="components_loading-error">
    <div className="error-description">{text}</div>
  </div>
}

LoadingError.propTypes = {
  text: PropTypes.string.isRequired,
}

export default LoadingError
